import CreateInvestmentError from './CreateInvestmentError';
class InvalidPaymentPlanId extends CreateInvestmentError {
    constructor(options) {
        super('Payment plan id is not valid', options);
    }
}
export default InvalidPaymentPlanId;
